import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import WebIcon from '@mui/icons-material/Web';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StorageIcon from '@mui/icons-material/Storage';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import BrushIcon from '@mui/icons-material/Brush';
import './WebServices.css';

const services = [
  {
    icon: <WebIcon sx={{ fontSize: 40 }} />,
    title: 'Custom Web Applications',
    description: 'Tailored web solutions that perfectly align with your business requirements and user needs.'
  },
  {
    icon: <ShoppingCartIcon sx={{ fontSize: 40 }} />,
    title: 'E-Commerce Solutions',
    description: 'Powerful online stores with secure payment gateways, inventory management, and seamless user experience.'
  },
  {
    icon: <StorageIcon sx={{ fontSize: 40 }} />,
    title: 'Content Management',
    description: 'Easy-to-use CMS solutions that give you complete control over your website content.'
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: 'Progressive Web Apps',
    description: 'Fast, reliable, and engaging web applications that work offline and feel like native apps.'
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40 }} />,
    title: 'Web Security',
    description: 'Comprehensive security measures to protect your web applications and user data.'
  },
  {
    icon: <BrushIcon sx={{ fontSize: 40 }} />,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces that provide exceptional user experiences across all devices.'
  }
];

const WebServices = () => {
  return (
    <section className="web-services">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="web-section-title" gutterBottom>
            Our Web Development Services
          </Typography>
          <Typography variant="subtitle1" className="web-section-subtitle" gutterBottom>
            Comprehensive web solutions tailored to your needs
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="web-service-card">
                  <CardContent>
                    <div className="web-service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="web-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="web-service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default WebServices; 